import { render, staticRenderFns } from "./envioCorreos.vue?vue&type=template&id=24a3254e&scoped=true"
import script from "./envioCorreos.vue?vue&type=script&lang=js"
export * from "./envioCorreos.vue?vue&type=script&lang=js"
import style0 from "./envioCorreos.vue?vue&type=style&index=0&id=24a3254e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a3254e",
  null
  
)

export default component.exports